import { render, staticRenderFns } from "./StatsEvents.vue?vue&type=template&id=9b2278a4"
import script from "./StatsEvents.vue?vue&type=script&lang=js"
export * from "./StatsEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports